import React, { Component } from "react";
import logo from "../images/logo.svg";
import { withRouter } from "../components/withRouter";
import { LogoSvg } from "../components/loading";
import tochkaLogo from "../images/tochka_logo.webp";
import {
    AiOutlineDelete,
    AiOutlinePlus,
    AiOutlineArrowLeft,
    AiOutlineAudit,
    AiOutlineIdcard,
    AiOutlineInfoCircle,
} from "react-icons/ai";
import {
    hostsSettings,
    payment_subjects,
    units,
    vats,
    formPayments,
    timezones,
    is_internet,
    paymentTypes,
    calculationSigns,
    taxations,
} from "../configs/app.config";
import ConfirmaitonModal from "../components/confirmation_modal";
import moment from "moment";
import Header from "../components/header";
import { SelectArrowDown, SelectArrowTop } from "../components/selectArrow";
import CustomSelect from "../components/customSelect";
import copy from "copy-to-clipboard";

class NewSale extends Component {
    constructor(props) {
        super(props);
        this.state = {
            settings: [],
            isLoading: false,
            additionalClientData: false,
            contact: "",
            extraBuyerDataName: "",
            extraBuyerDataTin: "",
            sum: 0,
            postpaid_sum: 0,
            prepayment_sum: 0,
            products: [
                {
                    product: "",
                    sum: "",
                    pcount: 1,
                    //Мера количества (шт., кг ...)
                    unit: 255,
                    //Поставщик
                    agent: 0,
                    //Признак предмета расчета
                    subj_attribute: 1,
                    //Ставка НДС
                    vatRate: 6,
                    additionalSetting: false,
                },
            ],
            selectedFormPayment: 1,
            selectedPaymentType: 4,
            selectedCalculationSign: 1,
            selectedTaxation: null,
            paymentSettings: false,
            ord: "",
            sum_disable: true,

            paymentPage: true,

            // Модальное окно
            modalImage: "",
            modalTitle: "",
            modalDescription: "",
            modalOkText: "",
            modalCancelText: "Закрыть",
            confirmation: false,
            modalCloseAction: () => this.setState({ confirmation: false }),
            modalOkAction: () => this.setState({ confirmation: false }),

            legalEntities: [],
            legalEntitiesModal: false,
            legalEntitiesSelectOnly: false,

            linkModal: false,
            link: "",
            linkType: "full",
            timezone: 2,
            is_internet: 1,
            templateModal: false,
            templateName: "",
            selectedTemplatePay: 0,
            tochkaQRtext: "",
            tochkaQRLink: null,

            tochkaQRModalTTL: false,
            tochkaQRTTL: 60,
            tochkaQRTTLName: "60 минут",
            hiddenCustomOption: true,

            purpose: "",
        };

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(e) {
        const { name, value } = e.target;
        this.setState({
            [name]: value,
            error: "",
        });
    }

    onMIChange = (key, e) => {
        let name = e.target.name;
        let val = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        let products = this.state.products;
        products[key][name] = val;
        this.setState({ products });
    };

    ChangeInputPrice = (key, e) => {
        let regex = /^(0|[1-9][0-9]*)(\.[0-9]{0,2})?$/;
        let name = e.target.name;
        let value = e.target.value;
        let products = this.state.products;
        if (regex.test(value) || value == "") {
            products[key][name] = value;
            this.setState({ products });
        }
        this.calcAllSum();
    };

    ChangeAdditionalSettings = (key, e) => {
        let products = this.state.products;
        let val = products[key].additionalSetting == true ? false : true;
        products[key].additionalSetting = val;
        this.setState({ products });
    };

    ChangeProductCount = (key, e, event) => {
        let products = this.state.products;

        if (event == "minus") {
            if (products[key].pcount > 1) {
                --products[key].pcount;
            }
        } else {
            ++products[key].pcount;
        }

        this.setState({ products });
        this.calcAllSum();
    };

    backAction = () => {
        window.location.search == "?template" ? this.props.navigate("/templates") : this.props.navigate("/sales");
    };

    getSettings() {
        this.setState({ isLoading: true });
        fetch(hostsSettings.apiPage + "/settings", {
            headers: new Headers({
                Accept: "application/json",
                "Content-Type": "application/json; charset=utf-8",
                Authorization: "Bearer " + localStorage.getItem("digitalkassir_idtn_cms_frm"),
            }),
            method: "GET",
            cache: "no-cache",
            mode: "cors",
            credentials: "include",
        })
            .then((res) => res.json())
            .then((res) => {
                if (!res.error) {
                    if (res[0].agents && res[0].agents.length > 0) {
                        res[0].agents.push({
                            id: 0,
                            name: "Без агента",
                        });
                    }
                    this.setState({
                        settings: [...res].sort((a, b) => a.cashboxId - b.cashboxId)[0],
                        timezone: res[0].timezone == null ? 2 : res[0].timezone,
                        is_internet: res[0].is_internet == null ? 1 : res[0].is_internet,
                        isLoading: false,
                        selectedTaxation: res[0].tax || null,
                    });
                }
            });
    }

    addProduct() {
        let products = this.state.products;
        products.push({
            product: "",
            sum: "",
            pcount: 1,
            unit: 255,
            agent: 0,
            subj_attribute: 1,
            vatRate: 6,
            additionalSetting: false,
        });
        this.setState({ products });
    }

    deleteProduct = (key, e) => {
        let products = this.state.products;
        if (products.length > 1) {
            products.splice(key, 1);
            this.setState({ products });
            this.calcAllSum();
        }
    };

    handleSelectClickUnit = (id, name, index) => {
        let products = this.state.products;
        products[index].unit = id;
        this.setState({ products });
    };

    handleSelectClickPaymentSubject = (id, name, index) => {
        let products = this.state.products;
        products[index].subj_attribute = id;
        this.setState({ products });
    };

    handleSelectClickSupplier = (id, name, index) => {
        let products = this.state.products;
        products[index].agent = id;
        this.setState({ products });
    };

    handleSelectClickVat = (id, name, index) => {
        let products = this.state.products;
        products[index].vatRate = id;
        this.setState({ products });
    };

    checkReceiptData() {
        this.state.products.forEach((prod) => {
            if (!prod.product.trim() || Number(prod.pcount) <= 0 || Number(prod.price) < 0) {
                return this.setState({
                    confirmation: true,
                    isLoading: false,
                    modalImage: "❌",
                    modalTitle: "Ошибочка :(",
                    modalDescription: "Заполните все обязательные поля",
                    modalCancelText: "Закрыть",
                });
            }
        });
        if (!this.state.contact.trim() || this.state.selectedTaxation == null) {
            return this.setState({
                confirmation: true,
                isLoading: false,
                modalImage: "❌",
                modalTitle: "Ошибочка :(",
                modalDescription: "Заполните все обязательные поля",
                modalCancelText: "Закрыть",
            });
        }
    }

    postReceipt() {
        this.checkReceiptData();
        this.setState({ isLoading: true });
        fetch(hostsSettings.apiPage + "/sales/create-receipt", {
            headers: new Headers({
                Accept: "application/json",
                "Content-Type": "application/json; charset=utf-8",
                Authorization: "Bearer " + localStorage.getItem("digitalkassir_idtn_cms_frm"),
            }),
            method: "POST",
            cache: "no-cache",
            mode: "cors",
            credentials: "include",
            body: JSON.stringify({
                products: this.state.products,
                email: this.state.contact,
                cashboxId: this.state.settings.cashboxId,
                paymentType: Number.parseInt(this.state.selectedFormPayment),
                p_type: Number.parseInt(this.state.selectedPaymentType),
                chType: Number.parseInt(this.state.selectedCalculationSign),
                site: -1,
                supplier: 0,
                taxation: this.state.selectedTaxation,
                correction: false,
                sum: Number.parseFloat(this.state.sum) || 0,
                postpaid_sum: Number.parseFloat(this.state.postpaid_sum) || 0,
                prepayment_sum: Number.parseFloat(this.state.prepayment_sum) || 0,
                is_internet: this.state.is_internet == null ? 1 : this.state.is_internet,
                timezone: this.state.timezone == null ? 2 : this.state.timezone,
                extraBuyerData: this.state.additionalClientData ? 1 : 0,
                extraBuyerDataName: this.state.extraBuyerDataName,
                extraBuyerDataTin: this.state.extraBuyerDataTin,
                ord: this.state.ord,
            }),
        })
            .then((res) => res.json())
            .then((res) => {
                if (!res.error) {
                    this.props.navigate("/sales");
                } else {
                    return this.setState({
                        confirmation: true,
                        isLoading: false,
                        modalImage: "❌",
                        modalTitle: "Ошибочка :(",
                        modalDescription: res.error,
                        modalCancelText: "Закрыть",
                    });
                }
            });
    }

    calcAllSum() {
        let inputs = this.state.products;
        let sum = this.state.sum;
        let fs = 0;

        if (inputs.length) {
            for (let i of inputs)
                fs +=
                    Math.round(
                        (
                            Number.parseFloat(typeof i.sum === "string" ? i.sum.replace(",", ".") : i.sum) *
                            Number.parseFloat(typeof i.pcount === "string" ? i.pcount.replace(",", ".") : i.pcount)
                        ).toFixed(2) * 100,
                    ) / 100;

            if (!fs) {
                sum = "";
            } else if (this.state.sum_disable) {
                sum = ((fs.toFixed(2) / 100) * 100).toFixed(2);
            } else {
                sum = "";
            }
        }

        this.setState({ sum: sum - this.state.prepayment_sum });
    }

    getTochkaInfo(e, action) {
        this.setState({ isLoading: true, linkType: e }, () => {
            fetch(hostsSettings.apiPage + "/sales/tochka/info", {
                headers: new Headers({
                    Accept: "application/json",
                    "Content-Type": "application/json; charset=utf-8",
                    Authorization: "Bearer " + localStorage.getItem("digitalkassir_idtn_cms_frm"),
                }),
                method: "POST",
                cache: "no-cache",
                mode: "cors",
                credentials: "include",
                body: JSON.stringify({
                    company: this.state.settings.cashboxId,
                }),
            })
                .then((res) => res.json())
                .then((response) => {
                    if (!response.error) {
                        if (response.legalEntities.length == 0) {
                            return this.setState({
                                confirmation: true,
                                isLoading: false,
                                modalImage: "❌",
                                modalTitle: "Ошибочка :(",
                                modalDescription: "У вас нет подходящих юр. лиц",
                                modalCancelText: "Закрыть",
                            });
                        }
                        this.setState({
                            legalEntitiesModal: true,
                            legalEntities: response.legalEntities,
                            isLoading: false,
                            legalEntitiesSelectOnly: action == "selectOnly" ? true : false,
                        });
                    } else {
                        // this.setState({ isLoading: false });
                        // return openNotification(response.error, 1, 3.5)
                    }
                });
        });
    }

    getForaBankLink() {
        this.checkReceiptData();
        this.setState({ isLoading: true });
        fetch(hostsSettings.apiPage + "/sales/forabank/link", {
            headers: new Headers({
                Accept: "application/json",
                "Content-Type": "application/json; charset=utf-8",
                Authorization: "Bearer " + localStorage.getItem("digitalkassir_idtn_cms_frm"),
            }),
            method: "POST",
            cache: "no-cache",
            mode: "cors",
            credentials: "include",
            body: JSON.stringify({
                products: this.state.products,
                email: this.state.contact,
                cashboxId: this.state.settings.cashboxId,
                paymentType: Number.parseInt(this.state.selectedFormPayment),
                p_type: Number.parseInt(this.state.selectedPaymentType),
                chType: Number.parseInt(this.state.selectedCalculationSign),
                site: -1,
                supplier: 0,
                taxation: this.state.selectedTaxation,
                correction: false,
                sum: Number.parseFloat(this.state.sum) || 0,
                postpaid_sum: Number.parseFloat(this.state.postpaid_sum) || 0,
                prepayment_sum: Number.parseFloat(this.state.prepayment_sum) || 0,
                is_internet: this.state.is_internet == null ? 1 : this.state.is_internet,
                timezone: this.state.timezone == null ? 2 : this.state.timezone,
                extraBuyerData: this.state.additionalClientData ? 1 : 0,
                extraBuyerDataName: this.state.extraBuyerDataName,
                extraBuyerDataTin: this.state.extraBuyerDataTin,
                ord: this.state.ord,
                amount: this.state.sum
            }),
        })
            .then((res) => res.json())
            .then((response) => {
                if (!response.error) {
                    if (response.link) {
                        this.setState({
                            isLoading: false,
                            link: response.link,
                            linkModal: true,
                            legalEntitiesModal: false,
                        });
                    } else {
                        return this.setState({
                            isLoading: false,
                            confirmation: true,
                            isLoading: false,
                            modalImage: "❌",
                            modalTitle: "Ошибочка :(",
                            modalDescription: "Юр. лицо не владеет услугой интернет-эквайринга, выберите другое",
                            modalCancelText: "Закрыть",
                        });
                        // return openNotification("Юр. лицо не владеет услугой интернет-эквайринга, выберите другое", 1, 3.5)
                    }
                } else {
                    return this.setState({
                        isLoading: false,
                        confirmation: true,
                        isLoading: false,
                        modalImage: "❌",
                        modalTitle: "Ошибочка :(",
                        modalDescription: response.error,
                        modalCancelText: "Закрыть",
                    });
                    // return openNotification(response.error, 1, 3.5)
                }
            });
    }

    getTochkaUrInfo(code) {
        this.setState({ isLoading: true }, () => {
            fetch(hostsSettings.apiPage + "/sales/tochka/retailers/code/" + code, {
                headers: new Headers({
                    Accept: "application/json",
                    "Content-Type": "application/json; charset=utf-8",
                    Authorization: "Bearer " + localStorage.getItem("digitalkassir_idtn_cms_frm"),
                }),
                method: "POST",
                cache: "no-cache",
                mode: "cors",
                credentials: "include",
                body: JSON.stringify({
                    company: this.state.settings.cashboxId,
                }),
            })
                .then((response) => response.json())
                .then((response) => {
                    if (!response.error) {
                        if (response.status == "ok") {
                            this.getTochkaLink(code);
                        } else {
                            return this.setState({
                                isLoading: false,
                                confirmation: true,
                                isLoading: false,
                                modalImage: "❌",
                                modalTitle: "Ошибочка :(",
                                modalDescription: "Юр. лицо не владеет услугой интернет-эквайринга, выберите другое",
                                modalCancelText: "Закрыть",
                            });
                            // return openNotification("", 1, 3.5)
                        }
                    } else {
                        // return openNotification(response.error, 1, 3.5)
                    }
                });
        });
    }

    getTochkaLink(code) {
        let names = "";
        let items = [];
        if (this.state.products.length == 1) {
            names = "Оплата: ";
        } else {
            names = "Оплата: ";
        }

        this.state.products.forEach((elem) => {
            names += elem.product + " ";
            let vat = "";
            let subj_attribute = "";
            let unit = "";

            switch (elem.vatRate) {
                case 6:
                    vat = "none";
                    break;
                case 5:
                    vat = "vat0";
                    break;
                case 4:
                    vat = "vat110";
                    break;
                case 3:
                    vat = "vat120";
                    break;
                case 2:
                    vat = "vat10";
                    break;
                case 1:
                    vat = "vat20";
                    break;
            }

            switch (elem.subj_attribute) {
                case 1:
                    subj_attribute = "goods";
                    break;
                case 4:
                    subj_attribute = "service";
                    break;
                case 10:
                // return openNotification("Для данного метода приема платежей доступные признаки пр-та расчета: Товар или Услуга", 1, 3.5);
            }

            switch (elem.unit) {
                case "0":
                    unit = "шт.";
                    break;
                case "10":
                    unit = "г.";
                    break;
                case "11":
                    unit = "кг.";
                    break;
                case "12":
                    unit = "т.";
                    break;
                case "20":
                    unit = "см.";
                    break;
                case "21":
                    unit = "дм.";
                    break;
                case "22":
                    unit = "м.";
                    break;
                case "30":
                    unit = "см2.";
                    break;
                case "31":
                    unit = "дм2.";
                    break;
                case "32":
                    unit = "м2.";
                    break;
                case "40":
                    unit = "мл.";
                    break;
                case "41":
                    unit = "л.";
                    break;
                case "42":
                    unit = "м3";
                    break;
                case "50":
                    unit = "кВт.ч.";
                    break;
                case "51":
                    unit = "Гкал.";
                    break;
                case "70":
                    unit = "дн.";
                    break;
                case "71":
                    unit = "ч.";
                    break;
                case "72":
                    unit = "мин.";
                    break;
                case "73":
                    unit = "сек.";
                    break;
                case "80":
                    unit = "Кб.";
                    break;
                case "81":
                    unit = "Мб.";
                    break;
                case "82":
                    unit = "Гб.";
                    break;
                case "83":
                    unit = "Тб.";
                    break;
                case "255":
                    unit = "шт.";
                    break;
            }

            items.push({
                vatType: vat,
                name: elem.product,
                amount: elem.sum,
                quantity: elem.pcount,
                discount: elem.discount,
                paymentMethod: "full_payment",
                paymentObject: subj_attribute,
                measure: unit,
            });
        });

        fetch(hostsSettings.apiPage + "/sales/tochka/payments/link", {
            headers: new Headers({
                Accept: "application/json",
                "Content-Type": "application/json; charset=utf-8",
                Authorization: "Bearer " + localStorage.getItem("digitalkassir_idtn_cms_frm"),
            }),
            method: "POST",
            cache: "no-cache",
            mode: "cors",
            credentials: "include",
            body: JSON.stringify({
                company: this.state.settings.cashboxId,
                products: this.state.products,
                email: this.state.contact,
                cashboxId: this.state.settings.cashboxId,
                paymentType: Number.parseInt(this.state.selectedFormPayment),
                p_type: Number.parseInt(this.state.selectedPaymentType),
                chType: Number.parseInt(this.state.selectedCalculationSign),
                site: -1,
                supplier: 0,
                taxation: this.state.selectedTaxation,
                correction: false,
                sum: Number.parseFloat(this.state.sum) || 0,
                postpaid_sum: Number.parseFloat(this.state.postpaid_sum) || 0,
                prepayment_sum: Number.parseFloat(this.state.prepayment_sum) || 0,
                is_internet: this.state.is_internet == null ? 1 : this.state.is_internet,
                timezone: this.state.timezone == null ? 2 : this.state.timezone,
                extraBuyerData: this.state.additionalClientData ? 1 : 0,
                extraBuyerDataName: this.state.extraBuyerDataName,
                extraBuyerDataTin: this.state.extraBuyerDataTin,
                ord: this.state.ord,

                customerCode: code,
                amount: this.state.sum,
                purpose: names,
                items: items,
                typeLink: this.state.linkType,
            }),
        })
            .then((res) => res.json())
            .then((response) => {
                if (!response.error) {
                    if (response.link) {
                        this.setState({
                            isLoading: false,
                            link: response.link,
                            linkModal: true,
                            legalEntitiesModal: false,
                        });
                    } else {
                        // return openNotification("Юр. лицо не владеет услугой интернет-эквайринга, выберите другое", 1, 3.5)
                    }
                } else {
                    // return openNotification(response.error, 1, 3.5)
                }
            });
    }

    handleSomeAction = () => {
        this.setState({ confirmation: false });
    };

    nameTemplate() {
        this.setState({ templateModal: true, templateName: "", legalEntitiesModal: false });
    }

    interimСheck() {
        if (this.state.selectedTemplatePay == 1) {
            this.getTochkaInfo("sbp", "selectOnly");
        } else if (this.state.selectedTemplatePay == 2) {
            this.getTochkaInfo("full", "selectOnly");
        } else {
            this.nameTemplate();
        }
    }

    saveTemplate() {
        this.setState({ isLoading: true, templateModal: false });
        fetch(hostsSettings.apiPage + "/templates/create", {
            headers: new Headers({
                Accept: "application/json",
                "Content-Type": "application/json; charset=utf-8",
                Authorization: "Bearer " + localStorage.getItem("digitalkassir_idtn_cms_frm"),
            }),
            method: "POST",
            cache: "no-cache",
            mode: "cors",
            credentials: "include",
            body: JSON.stringify({
                templateName: this.state.templateName,
                products: this.state.products,
                email: this.state.contact,
                cashboxId: this.state.settings.cashboxId,
                paymentType: Number.parseInt(this.state.selectedFormPayment),
                p_type: Number.parseInt(this.state.selectedPaymentType),
                chType: Number.parseInt(this.state.selectedCalculationSign),
                site: -1,
                supplier: 0,
                taxation: this.state.selectedTaxation,
                correction: false,
                sum: Number.parseFloat(this.state.sum) || 0,
                postpaid_sum: Number.parseFloat(this.state.postpaid_sum) || 0,
                prepayment_sum: Number.parseFloat(this.state.prepayment_sum) || 0,

                extraBuyerData: this.state.additionalClientData ? 1 : 0,
                extraBuyerDataName: this.state.extraBuyerDataName,
                extraBuyerDataTin: this.state.extraBuyerDataTin,
                selectedTemplatePay: this.state.selectedTemplatePay,
                legalEntitiesSelectOnly: this.state.legalEntitiesSelectOnly,
                ord: this.state.ord,
                paymentPage: this.state.paymentPage,
            }),
        })
            .then((res) => res.json())
            .then((res) => {
                if (!res.error) {
                    this.props.navigate("/templates");
                } else {
                    return this.setState({
                        confirmation: true,
                        isLoading: false,
                        modalImage: "❌",
                        modalTitle: "Ошибочка :(",
                        modalDescription: res.error,
                        modalCancelText: "Закрыть",
                    });
                }
            });
    }

    // downloadQR = (name) => {
    //   const link = document.createElement("a");
    //   link.href = `data:image/jpeg;base64,${this.state[name]}`;
    //   link.download = "image.jpeg";
    //   document.body.appendChild(link);
    //   link.click();
    //   document.body.removeChild(link);
    //   this.setState({ confirmation: false });
    //   this.props.navigate("/sales");
    // };

    // downloadQR = async (name) => {
    //   try {
    //     // Проверяем, доступен ли Telegram WebApp API
    //     if (window.Telegram && window.Telegram.WebApp) {
    //       const base64Data = this.state[name].replace(/^data:image\/jpeg;base64,/, "");

    //       // Конвертируем base64 в blob
    //       const byteCharacters = atob(base64Data);
    //       const byteArrays = [];

    //       for (let offset = 0; offset < byteCharacters.length; offset += 512) {
    //         const slice = byteCharacters.slice(offset, offset + 512);
    //         const byteNumbers = new Array(slice.length);

    //         for (let i = 0; i < slice.length; i++) {
    //           byteNumbers[i] = slice.charCodeAt(i);
    //         }

    //         const byteArray = new Uint8Array(byteNumbers);
    //         byteArrays.push(byteArray);
    //       }

    //       const blob = new Blob(byteArrays, { type: "image/jpeg" });

    //       // Создаем файл для отправки
    //       const file = new File([blob], "image.jpeg", { type: "image/jpeg" });

    //       // Используем Telegram API для отправки файла
    //       window.Telegram.WebApp.sendData(
    //         JSON.stringify({
    //           type: "download_image",
    //           filename: "image.jpeg",
    //           data: this.state[name],
    //         })
    //       );
    //     } else {
    //       // Fallback для браузера
    //       const link = document.createElement("a");
    //       link.href = `data:image/jpeg;base64,${this.state[name]}`;
    //       link.download = "image.jpeg";
    //       document.body.appendChild(link);
    //       link.click();
    //       document.body.removeChild(link);
    //     }

    //     this.setState({ confirmation: false });
    //     this.props.navigate("/sales");
    //   } catch (error) {
    //     console.error("Download error:", error);
    //   }
    // };

    getTochkaQrSBP() {
        if (this.state.purpose.trim() == "") {
            return this.setState({
                modalImage: "❌",
                modalTitle: "Ошибочка :(",
                modalDescription: "Не заполнено назначение платежа",
                modalCancelText: "Закрыть",
                confirmation: true,
                isLoading: false,
            });
        }
        fetch(hostsSettings.apiPage + "/sales/tochka/payments/qr", {
            headers: new Headers({
                Accept: "application/json",
                "Content-Type": "application/json; charset=utf-8",
                Authorization: "Bearer " + localStorage.getItem("digitalkassir_idtn_cms_frm"),
            }),
            method: "POST",
            cache: "no-cache",
            mode: "cors",
            credentials: "include",
            body: JSON.stringify({
                static: false,
                amount: this.state.sum,
                products: this.state.products,
                email: this.state.contact,
                cashboxId: this.state.settings.cashboxId,
                taxation: this.state.selectedTaxation,
                paymentType: Number.parseInt(this.state.selectedFormPayment),
                p_type: Number.parseInt(this.state.selectedPaymentType),
                chType: Number.parseInt(this.state.selectedCalculationSign),
                site: -1,
                supplier: 0,
                correction: false,
                purpose: this.state.purpose,
                sum: Number.parseFloat(this.state.sum) || 0,
                postpaid_sum: Number.parseFloat(this.state.postpaid_sum) || 0,
                prepayment_sum: Number.parseFloat(this.state.prepayment_sum) || 0,
                is_internet: this.state.is_internet == null ? 1 : this.state.is_internet,
                timezone: this.state.timezone == null ? 2 : this.state.timezone,
                extraBuyerData: this.state.additionalClientData ? 1 : 0,
                extraBuyerDataName: this.state.extraBuyerDataName,
                extraBuyerDataTin: this.state.extraBuyerDataTin,
                ttl: this.state.tochkaQRTTL,
                ord: this.state.ord,
            }),
        })
            .then((res) => res.json())
            .then((response) => {
                if (!response.error) {
                    this.setState({
                        tochkaQRModalTTL: false,
                        tochkaQRTTL: 60,
                        tochkaQRTTLName: "60 минут",
                        purpose: "",
                        tochkaQRtext: response.qr.image.content,
                        tochkaQRLink: response.qr.payload,
                        confirmation: true,
                        isLoading: false,
                        modalImage: (
                            <img
                                style={{ display: "block", margin: "0 auto" }}
                                src={`data:image/jpeg;base64,${response.qr.image.content}`}
                                alt={"qr_Tochka"}
                            />
                        ),
                        // modalOkAction: () => this.downloadQR("tochkaQRtext"),
                        modalCloseAction: () => {
                            copy(response.qr.payload);
                            this.props.navigate("/sales");
                        },
                        modalDescription: "",
                        // modalOkText: "Скачать",
                        modalCancelText: "Скопировать ссылку",
                        modalTitle: (
                            <div>
                                Успех
                                <br />
                                Сделайте скриншот или поделитесь ссылкой на qr
                            </div>
                        ),
                    });
                } else {
                    return this.setState({
                        tochkaQRModalTTL: false,
                        tochkaQRTTL: 60,
                        purpose: "",
                        tochkaQRTTLName: "60 минут",
                        confirmation: true,
                        isLoading: false,
                        modalImage: "❌",
                        modalTitle: "Ошибочка :(",
                        modalDescription: "Не удалось сгенерировать QR-код",
                        modalCancelText: "Закрыть",
                    });
                }
            });
    }

    render() {
        return (
            <div>
                <Header
                    back={<AiOutlineArrowLeft />}
                    backAction={this.backAction}
                    pageName={window.location.search == "?template" ? "Создание шаблона" : "Создание продажи"}
                />
                {this.state.isLoading ? (
                    <div className="loading_logo">
                        <LogoSvg />
                    </div>
                ) : (
                    ""
                )}

                <div className="products_list">
                    {this.state.products.map((product, index) => {
                        return (
                            <div key={"prod_" + index} className="product_item">
                                <div style={{ display: "flex", justifyContent: "space-between", gap: 15 }}>
                                    <div style={{ fontSize: 14, color: "var(--gray-dark)", marginBottom: 10 }}>
                                        Товар #{index + 1}
                                    </div>
                                    <AiOutlineDelete
                                        onClick={(e) => {
                                            this.deleteProduct(index, e);
                                        }}
                                        style={{ fontSize: 20, fill: "var(--primary-color)" }}
                                    />
                                </div>
                                <div className={"inputWithHint required"}>
                                    <p>Наименование</p>
                                    <input
                                        name="product"
                                        onChange={(e) => {
                                            this.onMIChange(index, e);
                                        }}
                                        value={product.product}
                                    />
                                </div>
                                <div className={"inputWithHint required"}>
                                    <p>Цена</p>
                                    <input
                                        name="sum"
                                        onChange={(e) => {
                                            this.ChangeInputPrice(index, e);
                                        }}
                                        value={product.sum}
                                    />
                                </div>
                                <div
                                    className={"inputWithHint"}
                                    style={{
                                        flexDirection: "row",
                                        gap: 15,
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                    }}>
                                    <p style={{ marginBottom: 0 }}>Кол-во</p>
                                    <div className="counter">
                                        <button
                                            name="pcount"
                                            onClick={(e) => {
                                                this.ChangeProductCount(index, e, "minus");
                                            }}>
                                            <span>-</span>
                                        </button>
                                        <input
                                            name="pcount"
                                            onChange={(e) => {
                                                this.ChangeInputPrice(index, e);
                                            }}
                                            value={product.pcount}
                                        />
                                        <button
                                            name="pcount"
                                            onClick={(e) => {
                                                this.ChangeProductCount(index, e, "plus");
                                            }}>
                                            <span>+</span>
                                        </button>
                                    </div>
                                </div>

                                {product.additionalSetting == false ? (
                                    <div
                                        onClick={(e) => {
                                            this.ChangeAdditionalSettings(index, e);
                                        }}
                                        className={"additional_settings_btn"}>
                                        <SelectArrowDown />
                                        Открыть доп. настройки
                                        <SelectArrowDown />
                                    </div>
                                ) : (
                                    <>
                                        <div
                                            onClick={(e) => {
                                                this.ChangeAdditionalSettings(index, e);
                                            }}
                                            className={"additional_settings_btn"}>
                                            <SelectArrowTop />
                                            Закрыть доп. настройки
                                            <SelectArrowTop />
                                        </div>
                                        <div className={"inputWithHint"}>
                                            <p>Ед. измерения</p>
                                            <CustomSelect
                                                itemEvent={this.handleSelectClickUnit}
                                                index={index}
                                                selectedItem={product.unit}
                                                items={units}
                                            />
                                        </div>

                                        {this.state.settings.isAgent ? (
                                            <div className={"inputWithHint"}>
                                                <p>Поставщик</p>
                                                <CustomSelect
                                                    itemEvent={this.handleSelectClickSupplier}
                                                    index={index}
                                                    selectedItem={product.agent}
                                                    items={this.state.settings.agents}
                                                />
                                            </div>
                                        ) : (
                                            ""
                                        )}

                                        <div className={"inputWithHint"}>
                                            <p>Признак предмета расчета</p>
                                            <CustomSelect
                                                itemEvent={this.handleSelectClickPaymentSubject}
                                                index={index}
                                                selectedItem={product.subj_attribute}
                                                items={payment_subjects}
                                            />
                                        </div>
                                        <div className={"inputWithHint"}>
                                            <p>Ставка НДС</p>
                                            <CustomSelect
                                                itemEvent={this.handleSelectClickVat}
                                                index={index}
                                                selectedItem={product.vatRate}
                                                items={vats}
                                            />
                                        </div>
                                    </>
                                )}
                            </div>
                        );
                    })}

                    <div
                        onClick={() => {
                            this.addProduct();
                        }}
                        className={"btn btn_tdk_transparent"}
                        style={{ marginTop: 15 }}>
                        <div className={"icon"}>
                            <AiOutlinePlus style={{ height: 20, width: 20 }} />
                        </div>
                        <div className={"btn_content"}>
                            <span>Добавить товар</span>
                        </div>
                    </div>
                </div>

                <hr />

                {window.location.search == "?template" ? (
                    ""
                ) : (
                    <div>
                        <div className={"inputWithHint required"}>
                            <p>
                                Email или телефон клиента{" "}
                                <span style={{ display: "block", color: "var(--gray-dark)", fontSize: "14px" }}>
                                    (10 цифр, без +7 или 8 в начале)
                                </span>
                            </p>
                            <input name="contact" value={this.state.contact} onChange={this.handleChange} />
                        </div>

                        <div style={{ display: "flex", gap: 15, margin: "15px 0", alignItems: "center" }}>
                            <input
                                type="checkbox"
                                id="additionalClientData"
                                name="additionalClientData"
                                defaultChecked={this.state.additionalClientData}
                                onChange={(e) => {
                                    this.setState({ additionalClientData: e.target.checked });
                                }}
                            />
                            <label style={{ lineHeight: "18px" }} htmlFor="additionalClientData">
                                Дополнительные данные покупателя (клиента)
                            </label>
                        </div>

                        <div className={"inputWithHint required"}>
                            <p>Часовая зона места расчета</p>
                            <CustomSelect
                                itemEvent={(id) => {
                                    this.setState({ timezone: id });
                                }}
                                index={""}
                                selectedItem={this.state.timezone}
                                items={timezones}
                            />
                        </div>
                        <div className={"inputWithHint required"}>
                            <p>Признак расчета в сети интернет</p>
                            <CustomSelect
                                itemEvent={(id) => {
                                    this.setState({ is_internet: id });
                                }}
                                index={""}
                                selectedItem={this.state.is_internet}
                                items={is_internet}
                            />
                        </div>

                        {this.state.additionalClientData ? (
                            <div>
                                <div className={"inputWithHint"}>
                                    <p>
                                        Наименование организации или фамилия, имя, отчество (при наличии), серия и номер
                                        паспорта покупателя (клиента)
                                    </p>
                                    <input
                                        name="extraBuyerDataName"
                                        value={this.state.extraBuyerDataName}
                                        onChange={this.handleChange}
                                    />
                                </div>

                                <div className={"inputWithHint"}>
                                    <p>ИНН покупателя (клиента). Если покупатель юр. лицо - ИНН обязательно</p>
                                    <input
                                        name="extraBuyerDataTin"
                                        value={this.state.extraBuyerDataTin}
                                        onChange={this.handleChange}
                                    />
                                </div>
                            </div>
                        ) : (
                            ""
                        )}
                    </div>
                )}

                <h4 style={{ marginBottom: 10, marginTop: 20 }}>Данные о продаже</h4>
                {this.state.paymentSettings == false ? (
                    <>
                        <div className="paymentSettings">
                            <div>
                                Вид оплаты:{" "}
                                {formPayments.find((item) => item.id === this.state.selectedFormPayment)?.name}
                            </div>
                            <div>
                                Тип оплаты:{" "}
                                {paymentTypes.find((item) => item.id === this.state.selectedPaymentType)?.name}
                            </div>
                            {this.state.selectedPaymentType == 4 ? (
                                <div>Сумма предоплатой: {this.state.prepayment_sum}</div>
                            ) : (
                                ""
                            )}
                            {this.state.selectedPaymentType == 5 ? (
                                <div>Сумма постоплатой: {this.state.postpaid_sum}</div>
                            ) : (
                                ""
                            )}
                            <div>
                                Признак расчета:{" "}
                                {calculationSigns.find((item) => item.id === this.state.selectedCalculationSign)?.name}
                            </div>
                            <div>
                                Налогообложение:{" "}
                                {taxations.find((item) => item.id === this.state.selectedTaxation)?.name}
                            </div>
                        </div>
                        <div style={{ display: "flex", gap: 15, margin: "15px 0 15px 0", alignItems: "center" }}>
                            <input
                                type="checkbox"
                                className="customCheckbox"
                                id="paymentSettings"
                                name="paymentSettings"
                                defaultChecked={this.state.paymentSettings}
                                onChange={(e) => {
                                    this.setState({ paymentSettings: e.target.checked });
                                }}
                            />
                            <label style={{ lineHeight: "18px" }} htmlFor="paymentSettings">
                                Изменить настройки
                            </label>
                        </div>
                    </>
                ) : (
                    <>
                        <div className={"inputWithHint required"}>
                            <p>Вид оплаты</p>
                            <CustomSelect
                                itemEvent={(id) => {
                                    this.setState({ selectedFormPayment: id });
                                }}
                                index={""}
                                selectedItem={this.state.selectedFormPayment}
                                items={formPayments}
                            />
                        </div>

                        <div className={"inputWithHint required"}>
                            <p>Тип оплаты</p>
                            <CustomSelect
                                itemEvent={(id) => {
                                    this.setState({ selectedPaymentType: id });
                                }}
                                index={""}
                                selectedItem={this.state.selectedPaymentType}
                                items={paymentTypes}
                            />
                        </div>

                        {this.state.selectedPaymentType == 4 ? (
                            <div className={"inputWithHint"}>
                                <p>Сумма предоплатой (зачетом аванса)</p>
                                <input
                                    name="prepayment_sum"
                                    value={this.state.prepayment_sum}
                                    onChange={this.handleChange}
                                />
                            </div>
                        ) : (
                            ""
                        )}

                        {this.state.selectedPaymentType == 5 ? (
                            <div className={"inputWithHint"}>
                                <p>Сумма постоплатой (в кредит)</p>
                                <input
                                    name="postpaid_sum"
                                    value={this.state.postpaid_sum}
                                    onChange={this.handleChange}
                                />
                            </div>
                        ) : (
                            ""
                        )}

                        <div className={"inputWithHint required"}>
                            <p>Признак расчета</p>
                            <CustomSelect
                                itemEvent={(id) => {
                                    this.setState({ selectedCalculationSign: id });
                                }}
                                index={""}
                                selectedItem={this.state.selectedCalculationSign}
                                items={calculationSigns}
                            />
                        </div>

                        <div className={"inputWithHint required"} style={{ marginBottom: 15 }}>
                            <p>Налогообложение</p>
                            <CustomSelect
                                itemEvent={(id) => {
                                    this.setState({ selectedTaxation: id });
                                }}
                                index={""}
                                selectedItem={this.state.selectedTaxation}
                                items={taxations}
                            />
                        </div>
                    </>
                )}

                <div className={"inputWithHint"} style={{ marginBottom: 30 }}>
                    <p>
                        Номер заказа
                        <span style={{ display: "block", color: "var(--gray-dark)", fontSize: "14px" }}>
                            Не обязательно, номер заказа из системы пользователя
                        </span>
                    </p>
                    <input name="ord" value={this.state.ord} onChange={this.handleChange} />
                </div>

                {/* <div style={{ marginBottom: 30 }}>
          Итоговая сумма товаров: {this.state.sum}
        </div> */}

                {window.location.search == "?template" ? (
                    <div>
                        <div style={{ marginTop: 15 }}>
                            <h3 style={{ marginBottom: 10 }}>Настройка оплаты</h3>
                            {(this.state.settings.tochkaJWT && this.state.settings.tochkaClientId) || this.state.settings.foraBankLink ? (
                                <div>
                                    <div className={"inputWithHint"} style={{ marginBottom: 30 }}>
                                        <p>Выберите нужный сервис приема оплаты</p>
                                        <CustomSelect
                                            itemEvent={(id) => {
                                                this.setState({ selectedTemplatePay: id });
                                            }}
                                            index={""}
                                            selectedItem={this.state.selectedTemplatePay}
                                            items={[
                                                {
                                                    id: 0,
                                                    name: "Не выбрано, пробить чек",
                                                },
                                                {
                                                    id: 1,
                                                    name: "Точка банк СБП",
                                                },
                                                {
                                                    id: 2,
                                                    name: "Точка банк СБП и карта",
                                                },
                                                {
                                                    id: 3,
                                                    name: "Точка СБП QR-код",
                                                },
                                                {
                                                    id: 4,
                                                    name: "ФОРАБАНК платежная ссылка",
                                                },
                                            ]}
                                        />
                                    </div>
                                    <div
                                        style={{
                                            display: "flex",
                                            gap: 15,
                                            margin: "15px 0 30px 0",
                                            alignItems: "center",
                                        }}>
                                        <input
                                            type="checkbox"
                                            className="customCheckbox"
                                            id="paymentPage"
                                            name="paymentPage"
                                            defaultChecked={this.state.paymentPage}
                                            onChange={(e) => {
                                                this.setState({ paymentPage: e.target.checked });
                                            }}
                                        />
                                        <label style={{ lineHeight: "18px" }} htmlFor="paymentPage">
                                            Создать страницу оплаты
                                        </label>{" "}
                                        <AiOutlineInfoCircle
                                            style={{ fontSize: "24px" }}
                                            onClick={() => {
                                                this.setState({
                                                    confirmation: true,
                                                    modalImage: "🧐",
                                                    modalTitle: "Страница оплаты",
                                                    modalDescription:
                                                        "При включении этой функции клиенту будет отправляться ссылка на страницу, где он самостоятельно заполнит свои данные, а также увидит товары и сумму заказа",
                                                    modalCancelText: "Понятно",
                                                });
                                            }}
                                        />
                                    </div>
                                </div>
                            ) : (
                                ""
                            )}
                        </div>

                        <button
                            onClick={() => {
                                this.interimСheck();
                            }}
                            style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
                            className={"btn btn_tdk"}>
                            <AiOutlineAudit style={{ fill: "white", fontSize: 20, marginRight: 10 }} />
                            <span>Сохранить шаблон</span>
                        </button>
                    </div>
                ) : (
                    <div>
                        {this.state.settings.tochkaJWT && this.state.settings.tochkaClientId ? (
                            <div>
                                <button
                                    onClick={this.getTochkaInfo.bind(this, "sbp")}
                                    style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
                                    className={"btn btn_tdk tochka_btn"}>
                                    <img
                                        src={tochkaLogo}
                                        style={{ fill: "white", marginRight: 10, width: 20, height: 20 }}
                                    />
                                    <span>Точка банк СБП (ИЭ)</span>
                                </button>
                                <button
                                    onClick={this.getTochkaInfo.bind(this, "full")}
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        marginBottom: 10,
                                    }}
                                    className={"btn btn_tdk tochka_btn"}>
                                    <img
                                        src={tochkaLogo}
                                        style={{ fill: "white", marginRight: 10, width: 20, height: 20 }}
                                    />
                                    <span>Точка банк СБП и карта (ИЭ)</span>
                                </button>
                            </div>
                        ) : (
                            ""
                        )}

                        {this.state.settings.tochkaJWT &&
                        this.state.settings.tochkaClientId &&
                        this.state.settings.tochkaQrAccountId &&
                        this.state.settings.tochkaQrMerchantId ? (
                            <div>
                                <button
                                    onClick={() => {
                                        this.setState({ tochkaQRModalTTL: true });
                                    }}
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        marginBottom: 10,
                                    }}
                                    className={"btn btn_tdk tochka_btn"}>
                                    <img
                                        src={tochkaLogo}
                                        style={{ fill: "white", marginRight: 10, width: 20, height: 20 }}
                                    />
                                    <span>Точка СБП QR-код</span>
                                </button>
                            </div>
                        ) : (
                            ""
                        )}

                        {this.state.settings.foraBankLink ? (
                            <div>
                                <button
                                    onClick={() => {
                                        this.getForaBankLink();
                                    }}
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        marginBottom: 10,
                                        backgroundColor: "#e92415",
                                    }}
                                    className={"btn btn_tdk"}>
                                    <span>Платежная ссылка ФОРАБАНК</span>
                                </button>
                            </div>
                        ) : (
                            ""
                        )}

                        <button
                            onClick={() => {
                                this.postReceipt();
                            }}
                            style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
                            className={"btn btn_tdk"}>
                            <AiOutlineAudit style={{ fill: "white", fontSize: 20, marginRight: 10 }} />
                            <span>Пробить чек</span>
                        </button>
                    </div>
                )}

                {this.state.confirmation == true ? (
                    <ConfirmaitonModal
                        closeAction={this.state.modalCloseAction}
                        okAction={this.state.modalOkAction}
                        image={this.state.modalImage}
                        title={this.state.modalTitle}
                        description={this.state.modalDescription}
                        okText={this.state.modalOkText}
                        cancelText={this.state.modalCancelText}
                    />
                ) : (
                    ""
                )}

                {this.state.legalEntitiesModal == true ? (
                    this.state.legalEntities.length > 0 ? (
                        <div className="legalEntities">
                            <div className="legalEntities_bg"></div>
                            <div className="legalEntities_items">
                                <h3 style={{ marginBottom: 15 }}>Выберите юр. лицо</h3>
                                {this.state.legalEntities.map((elem, index) => {
                                    return (
                                        <div
                                            onClick={() => {
                                                if (this.state.legalEntitiesSelectOnly == true) {
                                                    this.setState({ legalEntitiesSelectOnly: elem.customerCode });
                                                    this.nameTemplate();
                                                } else {
                                                    this.getTochkaUrInfo(elem.customerCode);
                                                }
                                            }}
                                            className="legalEntitiesItem"
                                            key={index}>
                                            <div className="legalEntitiesItem__header">
                                                <AiOutlineIdcard />
                                                <div>{elem.shortName}</div>
                                            </div>
                                            <span style={{ color: "#afafaf", fontSize: "13px" }}>
                                                ИНН: {elem.taxCode}
                                            </span>
                                        </div>
                                    );
                                })}
                                <button
                                    className={"btn btn_tdk"}
                                    onClick={() => {
                                        this.setState({ legalEntitiesModal: false });
                                    }}
                                    style={{ marginTop: 15 }}>
                                    <span>Отмена</span>
                                </button>
                            </div>
                        </div>
                    ) : (
                        ""
                    )
                ) : (
                    ""
                )}

                {this.state.linkModal == true ? (
                    <div className="link_window">
                        <div className="link_window_body">
                            <div>Ваша ссылка: </div>
                            <input disabled value={this.state.link} />
                            <button
                                className={"btn btn_tdk"}
                                onClick={() => {
                                    copy(this.state.link);
                                    this.props.navigate("/sales");
                                }}>
                                Скопировать
                            </button>
                        </div>
                    </div>
                ) : (
                    ""
                )}

                {this.state.templateModal == true ? (
                    <div className="link_window">
                        <div className="link_window_body">
                            <div className={"inputWithHint"} style={{ width: "100%", marginBottom: 10 }}>
                                <p>Назовите шаблон</p>
                                <input
                                    name="templateName"
                                    value={this.state.templateName}
                                    onChange={this.handleChange}
                                />
                            </div>
                            <button
                                className={"btn btn_tdk"}
                                onClick={() => {
                                    this.saveTemplate();
                                }}>
                                <span>Сохранить</span>
                            </button>
                        </div>
                    </div>
                ) : (
                    ""
                )}

                {/* TODO переделать выбор времени !!!!  */}
                {this.state.tochkaQRModalTTL == true ? (
                    <div className="link_window">
                        <div className="link_window_body">
                            <div>Выберите срок жизни qr</div>
                            {this.state.hiddenCustomOption === true ? (
                                <div
                                    className="customSelect"
                                    onClick={() => {
                                        this.setState({ hiddenCustomOption: false });
                                    }}>
                                    <div className="defaultValue">
                                        {this.state.tochkaQRTTLName} {this.state.hiddenCustomOption === true}
                                    </div>
                                </div>
                            ) : (
                                ""
                            )}
                            {this.state.hiddenCustomOption === true ? (
                                ""
                            ) : (
                                <div className="customOptions">
                                    <div
                                        onClick={() =>
                                            this.setState({
                                                tochkaQRTTL: 60,
                                                hiddenCustomOption: true,
                                                tochkaQRTTLName: "60 минут",
                                            })
                                        }>
                                        60 минут
                                    </div>
                                    <div
                                        onClick={() =>
                                            this.setState({
                                                tochkaQRTTL: 1440,
                                                hiddenCustomOption: true,
                                                tochkaQRTTLName: "1 день",
                                            })
                                        }>
                                        1 день
                                    </div>
                                    <div
                                        onClick={() =>
                                            this.setState({
                                                tochkaQRTTL: 10080,
                                                hiddenCustomOption: true,
                                                tochkaQRTTLName: "1 неделя",
                                            })
                                        }>
                                        1 неделя
                                    </div>
                                    <div
                                        onClick={() =>
                                            this.setState({
                                                tochkaQRTTL: 43200,
                                                hiddenCustomOption: true,
                                                tochkaQRTTLName: "1 месяц",
                                            })
                                        }>
                                        1 месяц
                                    </div>
                                </div>
                            )}
                            <div className={"inputWithHint required"} style={{ width: "100%", marginBottom: 20 }}>
                                <p>Введите назначение платежа</p>
                                <input name="purpose" onChange={this.handleChange} value={this.state.purpose} />
                            </div>
                            <button
                                className={"btn btn_tdk"}
                                onClick={() => {
                                    this.getTochkaQrSBP();
                                }}>
                                <span>Выбрать</span>
                            </button>
                            <button
                                type="cancel"
                                className={"btn btn_tdk"}
                                onClick={() => {
                                    this.setState({ tochkaQRModalTTL: false });
                                }}>
                                <span>Закрыть</span>
                            </button>
                        </div>
                    </div>
                ) : (
                    ""
                )}
            </div>
        );
    }

    componentDidMount() {
        this.getSettings();
    }
}

export default withRouter(NewSale);
